import { OFLC_SEND_INVITATION_FAILED, OFLC_SEND_INVITATION_SUCCESS } from "../actions/action_sendInvitation";

const initialState = {
  error: null,
  data: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case OFLC_SEND_INVITATION_FAILED:
      return {
        ...state,
        data: null,
        error: action.payload,
      };
    case OFLC_SEND_INVITATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    default:
      return state;
  }
}
